import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Empty_FeildActivity_Interface, FeildActivity_Interface } from 'src/app/Interface/FeildActivity_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { ExpirationService } from 'src/app/Service/Expiration/Expiration.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';

@Component({
  selector: 'app-ExpirationAdd',
  templateUrl: './ExpirationAdd.component.html',
  styleUrls: ['./ExpirationAdd.component.scss']
})
export class ExpirationAddComponent implements OnInit {

  Token:String=""

  constructor(
    private Expiration_Service:ExpirationService,
    private Nav_Service:NavService,
    private Alertify_Service:AlertifyService
  ) { }

  ngOnInit() {
    this.Token=localStorage.getItem('Daro_User_Token');

    this.AddNewExpiration=new FormGroup({
      id :new FormControl(),
      Title:new FormControl(null,Validators.required),
      Day:new FormControl(null,Validators.required),
    })

    this.Nav_Service.CheckValidPage(this.Token,19).subscribe(
      data=>{

      }
      ,error=>{
        localStorage.clear()
        location.reload();
      }
    )


  }


  //#region  Form Add

  AddNewExpiration:FormGroup;

  get_Form_Title(){
    return this.AddNewExpiration.get('Title') as FormControl;
  }

  get_Form_Day(){
    return this.AddNewExpiration.get('Day') as FormControl;
  }

  //#endregion

  InProccessing:boolean=false

  SubmitAddNewExpiration(){
    var Record:FeildActivity_Interface =Empty_FeildActivity_Interface()
    Record.id=0
    Record.title=this.get_Form_Title().value
    Record.code=this.get_Form_Day().value
    this.InProccessing=true
    this.Expiration_Service.AddExpiration(Record,this.Token).subscribe(
      data=>{
        this.InProccessing=false
        if(data.id==-2){
          this.Alertify_Service.ErrorMessage("The entered title already exists in the list")
        }
        else{
          this.AddNewExpiration.reset()
          this.Alertify_Service.SuccessMessage("The information was registered successfully")
        }
      },error=>{
        localStorage.clear()
        location.reload();

      }
    )
  }


}
